var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navprofile-menu__item"},[_c('router-link',{staticClass:"navprofile-menu__item-routerlink",attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }